import React from 'react';
import Logo from './Logo';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  logos: {
    marginTop: 10,
    padding: '0 calc((100% - 692px)/2)',
    boxSizing: 'border-box',
    '& .gatsby-image-wrapper': {
      width: '100%',
      maxHeight: 80,
      '& img': {
        objectFit: 'contain!important'
      }
    },
  },
  logo: {
    padding: '15px 30px',
    [theme.breakpoints.down('xs')]: {
      padding: '10px 15px',
    }
  }
}));

const Logos = (props) => {

  const renderLogos = () => {
    return props.items.map((item, index) => {
      return (
        <Grid className={classes.logo} item container xs={4} justifyContent='center' key={index}>
          <Logo key={index} id={item} />
        </Grid>
      );
    });
  }

  const classes = useStyles();
  return(
    <Grid container justifyContent='center'>
      <h2>{props.lang === 'en-CA' ? 'Clients that trust us' : 'Des clients qui nous font confiance'}</h2>
      <Grid className={classes.logos} container sm={12} item justifyContent='center' alignItems='center'>
        {renderLogos()}
      </Grid>
    </Grid>
  )
}

export default Logos;